import PhoneInput from 'react-phone-input-2';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './PhoneNumberInput.module.scss';
import ValidationErrorLabel from '../../ValidationErrorLabel/ValidationErrorLabel';

export function PhoneNumberInput({ onChange, phone, disabled = false, error }) {
  const { t } = useTranslation();
  return (
    <div className={styles.PhoneNumberInput}>
      <div className={styles.label}>{t('common.forms.phone')}</div>
      <PhoneInput
        containerClass={styles.containerClass}
        inputClass={styles.inputClass}
        buttonClass={styles.buttonClass}
        value={phone}
        onChange={onChange}
        disabled={disabled}
      />
      {error && <ValidationErrorLabel message={error} />}
    </div>
  );
}
